import React from 'react'

import { useHistory } from "react-router-dom";
import { Translate } from '../../../language';
import Button from '../../../utils/components/Button/Button';

import './TabProfile.css'

const TabZone= ({ _id }) => {
    const history = useHistory()
    return (
        <div className={`content-tabs-zone ${!history.location.pathname.split('/')[4] ? 'without-post' : ''}`}>
            <Button onClick={() => { history.push('/Zones/Zone/' + _id) }} className="parent-width" text={Translate('publications', 'es')} theme={!history.location.pathname.split('/')[4] ? '' : 'white'} />
            <Button onClick={() => { history.push('/Zones/Zone/' + _id + '/Members') }} className="parent-width" text={Translate('members', 'es')} theme={history.location.pathname.includes('Members') ? '' : 'white'} />
        </div>
    )
}

export default TabZone
